// main.jsx
import './instrument.js';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import * as Sentry from '@sentry/react';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';
// import { useAppVersion } from 'src/versioning/VersionContext';
import { VersionProvider } from 'src/versioning/VersionContext';

import App from './App';
import { Fallback } from './components/Fallback';
import AuthState from './context/auth/authState';
import { PaymentProvider } from './context/BraintreeContext.jsx';
import NewBusinessState from './context/newBusiness/newBusinessState';
import PreQualificationState from './context/preQualification/preQualificationState.jsx';
import PreQualificationPagesState from './context/preQualPages/preQualificationPagesState';
import SharedDataState from './context/sharedData/sharedDataState';

//* ----------------------------------------------------------------

const errorHandler = (error, errorInfo) => {
  Sentry.captureException(new Error(error));
  Sentry.captureMessage(errorInfo);
};

if (import.meta.env.MODE === 'production') {
  // replace console.* for disable log on production
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

//* We don't need people to be able to use devtools on our app in Production.
//* so, we remove them.
if (import.meta.env.MODE !== 'localdev') {
  disableReactDevTools();
}

export default function VersionedPreQualProvider({ children }) {
  // const version = useAppVersion();

  // Pick the provider at runtime
  // const Provider = version === 'v1' ? PreQualificationState : PreQualificationStateV2;

  const Provider = PreQualificationState;

  return (
    <Suspense fallback={<div>Loading Context…</div>}>
      <Provider>{children}</Provider>
    </Suspense>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={Fallback} showDialog onError={errorHandler}>
      <HelmetProvider>
        <BrowserRouter>
          <VersionProvider>
            <AuthState>
              <PaymentProvider>
                <NewBusinessState>
                  <VersionedPreQualProvider>
                    <PreQualificationPagesState>
                      <SharedDataState>
                        <App />
                      </SharedDataState>
                    </PreQualificationPagesState>
                  </VersionedPreQualProvider>
                </NewBusinessState>
              </PaymentProvider>
            </AuthState>
          </VersionProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
